module.exports = {
    menu: {
        index:'INDEX',
        brand: 'BRAND MATRIX',
        investor: 'INVESTOR',
        news: 'NEWS',
        hr: 'HR',
        serveice: 'Complaints and Suggestions'
    },
    brand: {
        hla: 'HLA',
        hla_heans: 'HLA JEANS',
        ovv: 'OVV',
        heylads: 'HEYLADS',
        yeehoo: 'YeeHoO',
        sancanal: 'SANCANAL',
        hla_home: 'HEILAN HOME',
        hla_f2c: 'HLAF2C'
    },
    aside: {
        stock: 'Stock information',
        name: 'Stock quotation'
    },
    shopname:'OFFICIAL MALL',
    shoplink:'OFFICIAL WEBSITE',
    top:'TOP',
    more: 'MORE',
    text: 'Text',
    news_detail: 'News Detail',
    temporary_announcement: 'Temporary announcement',
    regular_announcement: 'Regular announcement',
    board_of_directors:'Board of directors',
    board_of_supervisors: 'Board of supervisors',
    other_executives:'Other executives',
    privacy_policy: 'Privacy policy'
}


// WEBPACK FOOTER //
// ./src/lang/en.js